import { NO_DATA_INFO } from '../../../types';

const NoDataElement = () => (
    <span className="text-color-lighter" data-testid="no-data-info">
        {NO_DATA_INFO}
    </span>
);
export default NoDataElement;
